
















































































	import { Component, Vue } from "vue-property-decorator";
	import Axios from "axios";
	import DniField from "@/components/DniFieldBusiness.vue";
	import DniBusiness from "@/components/dniBusiness/DniFieldBusiness.vue";
	import Modals from "@/components/modals/Modals.vue";
	import AlertasSnack from "@/components/alertas/AlertasSnack.vue";
	import {
		Configuration,
		SelectedCountry,
		RedCapital,
		TitleTemplateDashboard,
	} from "@/configuration";
	import API from "@/api";
	import { isRutValid } from "@/utils";
	import { EventBus } from "@/main";
	import { mapState } from "vuex";
	import { DniTrim } from "@/utils";

	@Component({
  		computed: { ...mapState(["user"]) },
  		metaInfo: {
			title: "Crear tu negocio",
			titleTemplate: TitleTemplateDashboard,
			htmlAttrs: {
				// @ts-ignore
				lang: RedCapital[SelectedCountry].Lang,
			},
  		},
  		data() {
    		return {
				SelectedCountry,
				RedCapital,
				valid: true,
				loading: false,
				restore:'',
				loading2:false,
				disabledName: true,
				rutValid: false,
				dialog: false,
				errorMessage: null,
				progress:'',
				errorRut: null,
				errorPhone: null,
				errorDescription: null,
				errorRut404: null,
				rutInfo: null,
				rutInfo2: null,
				sale: [
					{
						id: 1,
						text: "Personas",
					},{
						id: 2,
						text: "Empresas",
					},{
						id: 3,
						text: "Ambas",
					},
				],
				form: {
					name: "",
					dni: "",
					phone: null,
					address: "",
					debt: "",
					web: "",
					description: "",
					radios: "siiPassword",
					folder: null,
					siiPassword: "",
					businessName: "",
					order: "",
					sales: null,
					id: this.$store.state.user.id,
				},
				rules: {
					name: [(v: any) => !!v || "Nombre es requerido"],
					// @ts-ignore
					dni: [ (v: any) => !!v || "Rut es requerido", ],
					phone: [ (v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros", ],
					address: [(v: any) => !!v || "Dirección es requerido"],
					debt: [(v: any) => !/[^\d]/gim.test(v) || "Tiene que ser solo numeros"],
					description: [
						(v: any) =>
							v.length <= 255 || "Descripción no puede exceder los 255 caracteres",
					],
					sales: [(v: any) => !!v || "Selecciona una opción"],
					noVacio: [
						// @ts-ignore
						v => {
							if(!v || v.trim() === ''){
								return 'Campo requerido'
							}else if(v.trim() === '0'){
								return 'Campo requerido'
							}else{
								return true
							}
						}
					],
				},
				plh: '',
				modalTipo: 0,
				snackData:{ // Objeto con la data de las alertas
					show: false,
					mensaje: '',
					tipo: false,
					idTime: null,
					loading: false
				},
			};
  		},
		/* 
			Valida que el usuario logeado sea del tipo AngloAmerican
			del caso contrario es devuelto al Home de RC.
		*/
		beforeRouteEnter  (to, from, next) {
			next(vm => {
				if (vm.$store.state.user.via_id != 2){
					vm.$router.push('/')
				}
			});
		},
		beforeMount(){
			/* 
				Validamos que el usuario anglo posea al menos un negocio registrado
				para poder redireccionarlo al panel principal.
			*/
			if(this.$store.state.user.empresas_count > 0){
				this.$router.push({
					path: "/panel-facto/estadisticas",
				});
			}
		},
  		methods: {
			validate() {
				// @ts-ignore
				if (this.$refs.form.validate()) {
					this.$data.valid = true;
					let objData = {
						clavesii: "",
						descripcion: "",
						deuda: "",
						direccion: "",
						empresa_target_id: null,
						giro: "",
						nombre: this.$data.form.name.trim(),
						pagina_web: "",
						razon_social: "",
						rut: this.$data.form.dni.split('.').join(''),
						telefono: null,
						user_id: this.$store.state.user.id
					}

					API.createBusiness(objData)
						.then((res: any) => {
							this.$data.dialog = true;
							this.$store.commit("setBusinessSelected", res);
							this.$store.commit("setBusiness", res.id);
							this.$store.commit("setEmpresasCount", +1);
							setTimeout(() => {
								this.$router.push({
									path: "/panel-facto/estadisticas",
								});
							}, Configuration.Redirection.timeout);
					})
					.catch((err: any) => {
						// @ts-ignore
						this.showAlerta({ show: true, mensaje: 'Error al crear el negocio, intente nuevamente. ', tipo: false,});									
					});
				}
    		},
			dataResponse(data){
				API.stateBusiness(this.$data.form.dni.split('.').join(''))
					.then((res:any)=>{
						if(res.data.message == "Crear"){ // Evalua si el rut ingresado se puede crear
							if(data.data.presenta_inicio_actividades == 'NO'){ // Evalua si tiene inicio de actividad para setar o no el valor de nombre
								this.$data.plh = 'Ingresa el nombre completo';
								this.$data.disabledName = false;

							}else{ 
								this.$data.plh = '';
								this.$data.disabledName = true;
								this.$data.form.name = data.data.razon_social;
							}
						} else { // Si no se puede crear despliega modal avisando que el rut ya esta registrado por la persona
							// @ts-ignore
							this.modal(13);
						}
					})
					.catch((err:any)=>{
						if(err.response.data.message == 'Registada por 3ro'){ // Muestra mensaje indicando el rut fue registrado por otra persona
							// @ts-ignore
							//this.$refs.formularioStep2.reset()
							// @ts-ignore
							this.modal(12);
							//this.$data.btnSeleccionarEmpresa = false;
						}
					})
			},
			modal(tipo){
				this.$data.modalTipo = 0;
				setTimeout(() => {
					this.$data.modalTipo = tipo;	
				});
			},
			showAlerta(data){ // Funcion necesaria para mostrar los snack bar de alertas
				this.$data.snackData.idTime = setTimeout(() => {
					this.$data.snackData.show = false;
					if(this.$data.snackData.loading){
						this.$data.snackData.loading = false;
					}	
				}, 5000);
				this.$data.snackData.show = data.show;
				this.$data.snackData.mensaje = data.mensaje;
				this.$data.snackData.tipo = data.tipo;
				this.$data.snackData.loading = data.loading;
			},
			showSnackVar(){ 
				clearTimeout(this.$data.snackData.idTime);
				this.$data.snackData.show = false;
			},
			limpiarModal7(){
				// @ts-ignore
				/* this.$refs.formularioStep2.reset();
				this.$data.btnSeleccionarEmpresa = false;
				this.$data.inicioActividades = false;
				this.$data.placeHolder = '';
				this.$data.formStep2.empresa.nombreParcial = ''; */
				//console.log('LIMPIAR FORMULARIO!!!');
			}
  		},
  		components: {
    		DniField,
			DniBusiness,
			Modals,
			AlertasSnack
  		},
	})
	export default class CreaNegocio extends Vue {}
